/* VitaWoof PDP tier control (vw2). Stacked layout: tiles carry ONE static price and
   never reprice; the purchase rows (Einmal kaufen / Spar-Abo) hold server-rendered
   per-variant price spans (.vw2bx__pv) that this script switches on variant change.
   - Tap a tile → drive the buy form's input[name="id"] (vw-pdp-abo.js observes it →
     re-commits + fires vw:plan-change → sticky bar syncs) + drive the hidden stock
     <variant-picker> so Horizon fires variant:update. Reliable, no fetch dependency.
   - Mode selection itself is owned by the protected controller (data-vw-card rows).
   FROZEN: never invent variant:update; never rename the vw:plan-change 'text'/'planId' fields. */
(function () {
  function init(root) {
    if (!root || root.__vw2TiersInit) return;
    root.__vw2TiersInit = true;
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-vw2-tier]'));
    if (!tiles.length) return;

    function section() { return root.closest('.shopify-section') || document; }
    function picker() { return section().querySelector('variant-picker'); }
    function buyForm() {
      var sec = section();
      var abo = sec.querySelector('vw-pdp-abo');
      return (abo && abo.closest('form')) || sec.querySelector('form[action*="/cart/add"]');
    }
    function mainIdInput() {
      var f = buyForm();
      return f ? f.querySelector('input[name="id"]') : null;
    }
    function radioFor(id) {
      var p = picker();
      return p ? p.querySelector('input[data-variant-id="' + id + '"]') : null;
    }
    function currentId() {
      var input = mainIdInput();
      return input ? input.value : null;
    }
    function setActive(id) {
      tiles.forEach(function (t) {
        var on = String(t.getAttribute('data-variant-id')) === String(id);
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      // Switch the purchase rows' per-variant price spans to the selected size.
      var pvs = section().querySelectorAll('[data-vw2-v]');
      Array.prototype.forEach.call(pvs, function (el) {
        el.classList.toggle('is-cur', String(el.getAttribute('data-vw2-v')) === String(id));
      });
    }
    function select(id) {
      if (!id) return;
      setActive(id);
      if (String(id) === String(currentId())) return;
      var input = mainIdInput();
      if (input) {
        input.value = id;
        input.setAttribute('value', id);
      }
      var radio = radioFor(id);
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    var engine = picker();
    if (engine) engine.classList.add('vw2-engine-hidden');

    // Dose-recommendation guard: the protected controller maps "Gross" to quantity 2
    // (written for a single-variant product). With tiered variants that would silently
    // charge 2x the displayed price. Honor the recommendation as the matching VARIANT
    // (2 Dosen) instead, and always clamp the submitted quantity to 1. This capture
    // listener registers AFTER the controller's (this script loads later), so it runs
    // after the controller re-asserts qty at submit time.
    var form = buyForm();
    if (form && !form.__vw2QtyGuard) {
      form.__vw2QtyGuard = true;
      form.addEventListener('submit', function () {
        var q = form.querySelector('input[name="quantity"]');
        if (q && q.value !== '1') q.value = '1';
      }, true);
      form.addEventListener('change', function (e) {
        if (!e.target || e.target.name !== 'quantity') return;
        var qty = parseInt(e.target.value, 10);
        if (!(qty > 1)) return;
        var tile = root.querySelector('[data-vw2-tins="' + qty + '"]');
        if (tile) select(tile.getAttribute('data-variant-id'));
        e.target.value = '1';
      });
    }

    tiles.forEach(function (t, idx) {
      t.addEventListener('click', function () { select(t.getAttribute('data-variant-id')); });
      t.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(t.getAttribute('data-variant-id')); }
        else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); var n = tiles[(idx + 1) % tiles.length]; n.focus(); select(n.getAttribute('data-variant-id')); }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); var p = tiles[(idx - 1 + tiles.length) % tiles.length]; p.focus(); select(p.getAttribute('data-variant-id')); }
      });
    });

    // Keep tiles + row prices in sync when the variant changes by any means.
    document.addEventListener('variant:update', function (e) {
      var v = e.detail && e.detail.resource;
      if (v && v.id != null) setActive(v.id);
    });

    var cur = currentId();
    if (cur) setActive(cur);
  }
  function boot() { document.querySelectorAll('[data-vw2-tiers]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Dose-link proxy: the visible "Wie viel braucht mein Hund?" link renders BELOW the
  // buy buttons (vw2-buy-buttons), but the protected controller only wires hooks inside
  // <vw-pdp-abo> (this.querySelector). Forward proxy clicks to the hidden real opener;
  // programmatic .click() fires listeners even on display:none elements.
  document.addEventListener('click', function (e) {
    var proxy = e.target.closest && e.target.closest('[data-vw2-dose-proxy]');
    if (!proxy) return;
    var real = document.querySelector('vw-pdp-abo [data-vw-dose-open]');
    if (real) real.click();
  });
})();
